if (!customElements.get('testimonial-slider')) {
  class TestimonialSlider extends HTMLElement {
    constructor() {
      super();

      this.click = false;
      this.$navItems = this.querySelectorAll('.slider-nav__item');
      this.$navItems.forEach($elm => {
        $elm.addEventListener('click', this.onNavClick.bind(this));
      });

      this.initSlider();

      this.navActiveClass = 'js-slider-nav-active';      
    }

    initSlider() {
      const autoplay = this.hasAttribute('data-autoplay') && this.hasAttribute('data-speed') ? this.getAttribute('data-speed') : false;

      let $slider = new Glide(this, {
        type: 'carousel',
        autoplay: autoplay,
        hoverpause: false
      });

      var self = this;
      $slider.on('run.before', function(e){
        const navCount = self.$navItems.length - 1;
        const dir = e.direction == ">" ? 1 : -1; 
        let index = $slider.index + dir;
        if( navCount == $slider.index && e.direction == ">" ){
          index = 0
        }else if( $slider.index == 0 && e.direction == "<" ){
          index = navCount;          
        } 

        if( !self.click ){
          self.setActiveSlide(index);          
        }
      });

      $slider.mount();

      this.$slider = $slider;
    }

    onNavClick(e) {
      this.click = true;

      const $elm = e.target;
      const itr = $elm.getAttribute('rel');
      this.setActiveSlide(itr);

      this.click = false;
    }

    setActiveSlide(itr) {
      this.resetNavItems();
      this.setActiveNavItem(itr);
      this.$slider.go(`=${itr}`);
    }

    setActiveNavItem(itr){
      this
        .$navItems[itr]
        .classList
        .add(this.navActiveClass);
    }

    resetNavItems(){
      this.$navItems.forEach($elm => {
        $elm.classList.remove(this.navActiveClass);
      });            
    }
  }

  customElements.define('testimonial-slider', TestimonialSlider);
}